/* =========================================
 * GLOBAL VARIABLES
 * ========================================= */
var coachMap;
var coachMarkers = [];
var profileOverlays = [];

/* =========================================
 * CUSTOM PROFILE OVERLAY
 * ========================================= */
function ProfileOverlay(position, image, map, infoWindow) {
    this.position = position;
    this.image = image;
    this.map = map;
    this.infoWindow = infoWindow;
    this.div = null;
    this.setMap(map);
}

ProfileOverlay.prototype = new google.maps.OverlayView();

ProfileOverlay.prototype.onAdd = function () {

    var div = document.createElement("div");
    div.className = "profile-marker";

    div.innerHTML = `
        <img src="${this.image}" class="profile-marker-img" />
    `;

    this.div = div;
    this.getPanes().overlayMouseTarget.appendChild(div);

    div.addEventListener("click", () => {
        this.infoWindow.setPosition(this.position);
        this.infoWindow.open(this.map);
    });
};

ProfileOverlay.prototype.draw = function () {

    var point = this.getProjection().fromLatLngToDivPixel(this.position);

    if (point && this.div) {
        this.div.style.left = (point.x - 22) + "px";
        this.div.style.top  = (point.y - 63) + "px";
        this.div.style.position = "absolute";
    }
};

ProfileOverlay.prototype.onRemove = function () {
    if (this.div) {
        this.div.remove();
        this.div = null;
    }
};

/* =========================================
 * INIT MAP
 * ========================================= */
function initMap(markersData = window.coachMapMarkers || []) {

    coachMap = new google.maps.Map(document.getElementById("map-canvas"), {
        center: { lat: 52.029167, lng: 5.643124 },
        zoom: 9
    });

    drawCoachMarkers(markersData);
}

/* =========================================
 * CLEAR MARKERS
 * ========================================= */
function clearCoachMarkers() {

    coachMarkers.forEach(marker => marker.setMap(null));
    coachMarkers = [];

    profileOverlays.forEach(overlay => overlay.setMap(null));
    profileOverlays = [];
}

/* =========================================
 * SPREAD DUPLICATES
 * Coaches are often saved with only a city name, so many
 * share identical lat/lng. Spiral duplicates around the
 * shared point so every marker is visible and clickable.
 * ========================================= */
function spreadDuplicateCoordinates(markers) {

    if (!markers || markers.length < 2) {
        return markers;
    }

    var groups = {};

    markers.forEach(function (item) {
        var key = Number(item.lat).toFixed(5) + "," + Number(item.lng).toFixed(5);
        (groups[key] = groups[key] || []).push(item);
    });

    var metersPerDegLat = 111320;
    var stepMeters      = 2000;
    var goldenAngle     = 2.39996;

    Object.keys(groups).forEach(function (key) {

        var group = groups[key];
        if (group.length < 2) {
            return;
        }

        var centerLat = Number(group[0].lat);
        var cosLat    = Math.cos(centerLat * Math.PI / 180) || 1;

        group.forEach(function (item, i) {
            if (i === 0) {
                return;
            }
            var angle  = i * goldenAngle;
            var radius = stepMeters * Math.sqrt(i);
            var dLat   = (radius * Math.cos(angle)) / metersPerDegLat;
            var dLng   = (radius * Math.sin(angle)) / (metersPerDegLat * cosLat);
            item.lat = Number(item.lat) + dLat;
            item.lng = Number(item.lng) + dLng;
        });
    });

    return markers;
}

/* =========================================
 * FIT MAP TO MARKERS
 * ========================================= */
function fitMapToMarkers(markers) {

    if (!coachMap) {
        return;
    }

    if (!markers || !markers.length) {
        coachMap.setCenter({ lat: 52.029167, lng: 5.643124 });
        coachMap.setZoom(9);
        return;
    }

    if (markers.length === 1) {
        coachMap.setCenter({ lat: Number(markers[0].lat), lng: Number(markers[0].lng) });
        coachMap.setZoom(12);
        return;
    }

    var bounds = new google.maps.LatLngBounds();
    markers.forEach(function (item) {
        bounds.extend(new google.maps.LatLng(Number(item.lat), Number(item.lng)));
    });
    coachMap.fitBounds(bounds, 60);
}

/* =========================================
 * DRAW MARKERS
 * ========================================= */
function drawCoachMarkers(markers, fitBounds) {

    clearCoachMarkers();

    if (!markers || !markers.length) {
        if (fitBounds) {
            fitMapToMarkers(markers);
        }
        return;
    }

    spreadDuplicateCoordinates(markers);

    if (fitBounds) {
        fitMapToMarkers(markers);
    }

    var orangeIcon = {
        url: "/app/uploads/2025/12/marker-orange.png",
        scaledSize: new google.maps.Size(60, 71)
    };

    markers.forEach(function (item) {

        var infoWindow = new google.maps.InfoWindow({
            content: `
                <div class="coach_tooltipBox">
                    <h6 class="tooltipTitle">
                        <a href="${item.url}">${item.title}</a>
                    </h6>
                    <div class="tooltipCon">Regio: ${item.regio}</div>
                    <div class="tooltipCon">Jeugd: ${item.jeugd}</div>
                </div>
            `
        });

        /* Default marker */
        var marker = new google.maps.Marker({
            position: { lat: item.lat, lng: item.lng },
            map: coachMap,
            icon: orangeIcon,
            title: item.title
        });

        marker.addListener("click", function () {
            infoWindow.open(coachMap, marker);
        });

        coachMarkers.push(marker);

        /* Profile image overlay */
        var overlay = new ProfileOverlay(
            new google.maps.LatLng(item.lat, item.lng),
            item.image,
            coachMap,
            infoWindow
        );

        profileOverlays.push(overlay);
    });
}

/* =========================================
 * LOAD MAP ON PAGE LOAD
 * ========================================= */
window.addEventListener("load", function () {
    if (typeof google !== "undefined") {
        initMap();
    } else {
        console.error("Google Maps API failed to load.");
    }
});
